import React, { PureComponent, ErrorInfo } from "react";
import { RouteComponentProps } from "@reach/router";

interface BasePureComponetProps extends RouteComponentProps {}

class BasePureComponet<
  Props extends BasePureComponetProps
> extends PureComponent<Props> {
  componentDidCatch = (error: Error, errorInfo: ErrorInfo) => {
    console.group("Error");
    console.error(error);
    console.error(errorInfo);
    console.groupEnd();
  };
}

export default BasePureComponet;
